import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./config/sentry";
import "./index.css";
import App from "./App.tsx";

// Initialize Sentry before React renders to capture all errors
initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
